import { Button, Grid, Paper, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  Control,
  FieldErrors,
  UseFormRegister,
  UseFormReset,
} from "react-hook-form";
import WSSelectField from "../../Components/Select/WSSelect";
import WSTextField, { TextType } from "../../Components/TextBox/WSTextBox";
import WSTextAreaField from "../../Components/WSTextArea/WSTextArea";
import {
  callAPI,
  customValidation,
  IRoleMain,
  IsSmallScreen,
  MasterPages,
  Method,
  validations,
} from "../../commonFunctions/CommonFunctions";
import PermissionDenied from "../../commonFunctions/PermissionDenied";
import { getPermissions } from "../../commonFunctions/PermissionManger";
import WSRadioField from "../../Components/Radio/WSRadio";
import { WSIcons } from "../../commonFunctions/iIcons";
import WSDateField from "../../Components/DateField/WSDateField";
import WSImageUpload from "../../Components/FileUpload/WSImageUpload";
import WSPhone from "../../Components/Phone/WSPhone";

interface MessageProps {
  control: Control<any>;
  errors: FieldErrors;
  register: UseFormRegister<any>;
  id: any;
  reset: UseFormReset<any>;
  departmentId?: string;
  setValue: any;
}
const Message: React.FC<MessageProps> = ({
  control,
  errors,
  register,
  id,
  reset,
  departmentId,
  setValue,
}) => {
  const isMobile = IsSmallScreen();
  useEffect(
    () => () => {
      reset();
    },
    [id, reset]
  );

  const [showDetails, setShowDetails] = useState(false);

  return (
    <>
      <Grid
        style={{
          paddingLeft: 5,
          paddingRight: 20,
          position: "relative",
          margin: 0,
          marginTop: "3rem",
        }}
        container
        spacing={2}
      >
        <Grid item xs={12}>
        <Typography>Dear, [Party Name] <br></br>
Your payment of [Amount] is pending with [Business Name]</Typography>
        </Grid>
        <Grid item xs={12} >
         <WSTextAreaField
              label={"Type additional message"}
              id={"additionalmessage"}
              name={"additionalmessage"}
              control={control}
              rules={{ required: false }}
              rows={3}
            />
        </Grid>
        <Grid item xs={12} >
         <Typography>If you have already made the payment, kindly ignore this message.</Typography>
        </Grid>
       
      </Grid>
    </>
  );
};
export default Message;
